import { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Wifi, WifiOff } from 'lucide-react';

export const NetworkIndicator = () => {
    const [isOnline, setIsOnline] = useState(navigator.onLine);
    const [showOnlineToast, setShowOnlineToast] = useState(false);

    useEffect(() => {
        const handleOnline = () => {
            setIsOnline(true);
            setShowOnlineToast(true);
            setTimeout(() => setShowOnlineToast(false), 3000);
        };

        const handleOffline = () => {
            setIsOnline(false);
            setShowOnlineToast(false);
        };

        window.addEventListener('online', handleOnline);
        window.addEventListener('offline', handleOffline);

        return () => {
            window.removeEventListener('online', handleOnline);
            window.removeEventListener('offline', handleOffline);
        };
    }, []);

    return (
        <div className="fixed top-4 left-1/2 -translate-x-1/2 z-[100] pointer-events-none">
            <AnimatePresence>
                {!isOnline && (
                    <motion.div
                        initial={{ y: -50, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        exit={{ y: -50, opacity: 0 }}
                        className="flex items-center gap-2 px-4 py-2 rounded-full bg-red-50/90 backdrop-blur-md border border-red-200 shadow-sm"
                    >
                        <div className="w-2 h-2 rounded-full bg-red-500 animate-pulse" />
                        <WifiOff className="w-4 h-4 text-red-500" />
                        <span className="text-sm font-medium text-red-700">You're offline</span>
                    </motion.div>
                )}

                {isOnline && showOnlineToast && (
                    <motion.div
                        initial={{ y: -50, opacity: 0 }}
                        animate={{ y: 0, opacity: 1 }}
                        exit={{ y: -50, opacity: 0 }}
                        className="flex items-center gap-2 px-4 py-2 rounded-full bg-emerald-50/90 backdrop-blur-md border border-emerald-200 shadow-sm"
                    >
                        <div className="w-2 h-2 rounded-full bg-emerald-500" />
                        <Wifi className="w-4 h-4 text-emerald-500" />
                        <span className="text-sm font-medium text-emerald-700">Back online!</span>
                    </motion.div>
                )}
            </AnimatePresence>
        </div>
    );
};
